import { Form, Input } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { InfoTooltip } from "./InfoTooltip";

export const BookyCustomInput = (props: any) => {

    const rules: any = [];
    if (props.requiredMessage) {
        rules.push({
            required: true,
            message: props.requiredMessage,
        });
    }

    return (
        <>
            <Form.Item label={props.infoText ? <span>{props.label}<InfoTooltip text={props.infoText} /></span> : props.label} name={props.name} extra={props.helpText ? <span style={{ justifyContent: 'left', display: "flex", fontSize: "80%" }}>{props.helpText}</span> : ""}
                rules={rules}
            >
                {props.children}
            </Form.Item>
        </>
    );

}